import React, { useCallback, useContext, useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import { navigate } from '@reach/router';
import moment from 'moment';

import { GlobalContext } from '../../../../store';
import { IEventItem } from '../../../../store/player/events/store';
import { ISeason } from '../../../../store/seasons/store';
import { IClub } from '../../../../store/player/clubs/store';

import { getEventField } from '../../../../contrib/Utils/getEventField';
import Button from '../../../../components/Button';
import { dateFormat } from '../../../../contrib/utils';
import { placeholderImage } from '../../../../assets/images';
import { isDateUCTSameAsToday } from '../../../../Utils/isDateUCTSameAsToday';

interface IProps {
  classNames?: string;
  currentSeason?: ISeason;
  clubId?: number;
}

export const ClubEventToday = (props: IProps) => {
  const { classNames, currentSeason, clubId } = props;

  const { events, games, clubs } = useContext(GlobalContext);

  const [todayEvent, setTodayEvent] = useState<IEventItem | undefined>(undefined);
  const [todayEvents, setTodayEvents] = useState<IEventItem[]>();
  const [userIsEnrolled, setUserIsEnrolled] = useState<boolean>();
  const [club, setClub] = useState<IClub | undefined>();

  useEffect(() => {
    if (events && events.all) {
      setTodayEvents(
        Object.values(events.all).filter((event: IEventItem) => {
          const isTodayEvent = isDateUCTSameAsToday(event.start);

          return clubId ? event.club.id === clubId && isTodayEvent : isTodayEvent;
        })
      );
    }
  }, [events, clubId]);

  useEffect(() => {
    if (todayEvents && todayEvents.length > 0) {
      setTodayEvent(todayEvents[0]);
    }
  }, [todayEvents]);

  useEffect(() => {
    if (todayEvent) {
      setUserIsEnrolled(
        Object.values(games).filter(game => game.round.event === todayEvent.id).length > 0
      );
    }
  }, [games, todayEvent]);

  const goToLeaderboard = useCallback(() => {
    if (todayEvent) {
      navigate(`/event/${todayEvent.id}/leaderboard`);
    }
  }, [todayEvent]);

  const checkCurrentSeason = useCallback(() => {
    if (currentSeason && todayEvent) {
      const todayEventStartDate = moment(todayEvent.start, dateFormat);
      const currentSeasonStartDate = moment(currentSeason.start, dateFormat);
      const currentSeasonEndDate = moment(currentSeason.end, dateFormat);

      return todayEventStartDate.isBetween(currentSeasonStartDate, currentSeasonEndDate);
    }
    return true;
  }, [todayEvent, currentSeason]);

  useEffect(() => {
    if (todayEvent && clubs && !!Object.keys(clubs.all).length) {
      setClub(clubs.all[todayEvent.club.id]);
    }
  }, [todayEvent, clubs]);

  return todayEvent && !userIsEnrolled && checkCurrentSeason() ? (
    <div className={`club-event-today ${classNames ? classNames : ''}`}>
      <Paper elevation={1} className="paper">
        <div className="club-event-today-header">
          <p>EVENT TODAY!</p>
        </div>

        <div className="club-event-today-body">
          <div
            className="bg-wrapper"
            style={{
              backgroundImage: `url(${todayEvent.image ? todayEvent.image : placeholderImage})`
            }}
          >
            <div className="bg-mask2" />
          </div>

          <div className="club-event-today-body-content">
            <h3>{club ? club.name : ''}</h3>

            <h2>{todayEvent.name}</h2>

            {todayEvent.club && (
              <div className="desc">
                <p>{moment(todayEvent.start).format('dddd, LL')}</p>

                <p>At {getEventField(todayEvent).name}</p>
              </div>
            )}
          </div>

          <Button
            id="add-players-submit"
            className="button button-shadow"
            color="primary"
            onClick={goToLeaderboard}
            type="button"
            variant="outlined"
          >
            WATCH LEADERBOARD
          </Button>
        </div>
      </Paper>
    </div>
  ) : (
    <></>
  );
};
